<template>
  <div class="multi-select-with-checkbox">
    <v-autocomplete
      v-model="selectedItems"
      :items="items"
      :placeholder="placeholder"
      :item-value="itemValue"
      :item-text="itemText"
      background-color="white"
      outlined
      dense
      multiple
    >
      <template v-slot:prepend-item>
        <v-list-item ripple @click="toggle">
          <v-list-item-action>
            <v-icon
              :color="selectedItems.length > 0 ? 'brand-01-emphasis' : ''"
              >{{ icon }}</v-icon
            >
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Select All</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </template>
      <template v-slot:selection="{ item, index }">
        <span v-if="index === 0">{{ item[itemText] }}</span>
        <span v-if="index === 1"> …+{{ selectedItems.length - 1 }}</span>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
// zeplin: https://app.zeplin.io/project/5f092773fa16ac9ddd3d2a2f/screen/5f0d0f46402f527e308cf261
// doc: https://vuetifyjs.com/en/components/selects/#prepend-append-item-slots
// doc: https://vuetifyjs.com/en/components/selects/#change-selection-appearance
// doc: https://vuetifyjs.com/en/components/autocompletes/#autocompletes

// items: something want to list on menu
// value: something check at menu

export default {
  props: {
    items: {
      type: Array,
      default() {
        return [];
      },
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    itemValue: {
      type: String,
      default: 'value',
    },
    itemText: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      selectedItems: this.value,
    };
  },
  watch: {
    // value() {
    //   this.selectedItems = this.value;
    // },
    selectedItems() {
      this.$emit('input', this.selectedItems);
    },
  },

  computed: {
    likesAllItem() {
      return this.selectedItems.length === this.items.length;
    },
    likesSomeItem() {
      return this.selectedItems.length > 0 && !this.likesAllItem;
    },
    icon() {
      if (this.likesAllItem) return 'mdi-close-box';
      if (this.likesSomeItem) return 'mdi-minus-box';
      return 'mdi-checkbox-blank-outline';
    },
  },

  methods: {
    toggle() {
      this.$nextTick(() => {
        if (this.likesAllItem) {
          this.selectedItems = [];
        } else {
          this.selectedItems = this.items.map((item) => item[this.itemValue]);
        }
      });
    },
  },
};
</script>

<style lang="scss">
// v-autocomplete
.multi-select-with-checkbox {
  .v-autocomplete {
    .v-input__slot {
      // border-top-left-radius: 0px;
      // border-bottom-left-radius: 0px;
      border-radius: 8px;
    }
    .v-text-field__details {
      display: none;
    }
  }

  // border
  fieldset {
    border-color: #d7dee7;
  }
  .v-input--is-focused {
    border-color: $brand-500;
  }

  // placeholder color
  input::placeholder {
    color: #848fa0 !important;
  }
}
</style>
